export const TOKEN_EXPIRATION_TIME_MS = 4.5 * 60 * 1000; // 4.5분(실제 5분)
export const REFRESH_TOKEN_EXPIRATION_TIME_MS = 1 * 24 * 60 * 60 * 1000; // 1일
